import React from "react";
import { makeStyles, Typography, ButtonBase, Box } from "@material-ui/core";

import { getModelName, formatPriceCents, getModelCategory } from "./utils";
import ProductImage from "../product/ProductImage";

function ProductListItem({ product, onDelete }) {
  const classes = useStyle();
  return (
    <div className={classes.container}>
      <ProductImage
        src={product.picture_new || product.pictures[0].url}
        addBrightness={!product.picture_new}
        product={product}
        alt={getModelName(product)}
        width="30%"
        maxWidth={200}
      />
      {product.isSold ? (
        <Box className={classes.grid}>
          {`Oups! Ce produit ${product.product_type} ${product.brand} ${product.model_reference} vient d'être acheté par un autre client`}
          {onDelete && (
            <ButtonBase className={classes.isSold} onClick={onDelete}>
              Supprimer
            </ButtonBase>
          )}
        </Box>
      ) : (
        <Box className={classes.grid}>
          <Box display="flex" width="100%" justifyContent="space-between">
            <Typography>{product.brand}</Typography>
            <Typography className={classes.price}>{formatPriceCents(product.price)}</Typography>
          </Box>
          <Box>
            <Typography>{getModelCategory(product)}</Typography>
            <Typography>{product.model_reference}</Typography>
          </Box>
          {onDelete && <ButtonBase onClick={onDelete}>Supprimer</ButtonBase>}
        </Box>
      )}
    </div>
  );
}

const useStyle = makeStyles((theme) => ({
  container: {
    display: "flex",
    alignItems: "flex-start",
    columnGap: theme.spacing(2),
  },
  price: {
    fontWeight: 700,
    marginLeft: theme.spacing(),
  },
  grid: {
    justifyItems: "start",
    display: "grid",
    gridRowGap: theme.spacing(2),
    width: "70%",
  },
  isSold: {
    color: theme.palette.error.main,
  },
  placeholder: {
    width: "30%",
    paddingBottom: "30%",
    backgroundColor: theme.palette.grey[200],
    marginRight: theme.spacing(2),
  },
}));

export default ProductListItem;
